import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

// Holds all the current experiments running in Blossom. Update and clean this as needed.
export enum Experiment {
  LOB_intent_search_button_text_hotels_pwa = "LOB_intent_search_button_text_hotels_pwa",
  Flex_HTG_Blossom_Recently_Viewed_Hotels = "Flex_HTG_Blossom_Recently_Viewed_Hotels",
  Bex_Bundle_AA_property_types_during_search = "Bex_Bundle_AA_property_types_during_search",
  Flex_Blossom_Qualtrics = "Flex_Blossom_Qualtrics",
  HTG_Add_Top_POI_Pins = "HTG_Add_Top_POI_Pins",
  PWA_ESS_Feedback_Loop_Enable = "PWA_ESS_Feedback_Loop_Enable",
  EG_UIDE_SDK_SF_test = "EG_UIDE_SDK_SF_test",
  Flex_HTG_Blossom_POSa_Redirect_Banner = "Flex_HTG_Blossom_POSa_Redirect_Banner",
  Destination_Orientation_we_dont_have_all_inclusive = "Destination_Orientation_we_dont_have_all_inclusive",
  Flex_typeahead_in_wizard = "Flex_typeahead_in_wizard",
  Add_Distance_to_Nearest_Points_on_Hotel_cards = "Add_Distance_to_Nearest_Points_on_Hotel_cards",
  BEX_TGFH_Increase_Affinity_Relevance = "BEX_TGFH_Increase_Affinity_Relevance",
  Dynamic_Map = "dynamic_map",
  Flex_HFTG_Affinity_Reviews = "Flex_HFTG_Affinity_Reviews",
  Flex_HTG_Blossom_Loyalty_signin_signup = "Flex_HTG_Blossom_Loyalty_signin_signup",
  Blossom_SRP_Lite_Desktop = "Blossom_SRP_Lite_Desktop",
  Blossom_SRP_Lite_Mobile = "Blossom_SRP_Lite_Mobile",
  New_Package_Form = "New_Package_Form",
  MIT_PWASF_PKGFLEXIBILITY_FSSSE = "MIT_PWASF_PKGFLEXIBILITY_FSSSE",
  Feature_Gate_MAB_on_SF = "Feature_Gate_MAB_on_SF",
  Flex_Blossom_Affinity_Pool_Filters = "Flex_Blossom_Affinity_Pool_Filters",
  LP_SC_Covid19_TravelAdvisory_for_LandingPages = "LP_SC_Covid19_TravelAdvisory_for_LandingPages",
  Chatbot_FAB_for_PWA = "Chatbot_FAB_for_PWA"
}

/**
 * Return bucket number of experiment.
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucket = (context: ExtendedContextStore, experimentName: Experiment): number =>
  context?.experimentContext?.experiments?.[experimentName];

/**
 * Checks if an experiment is in a given variant.
 * {@link https://tnl.prod.expedia.com}
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @param {number} value - Defaults to 1. Value that we are checking the experiment against
 * @returns {boolean} - True when the context contains an experiment string that matches a given numeric value
 */
export const isVariantEnabled = (
  context: ExtendedContextStore,
  experimentName: Experiment,
  value: number = 1
): boolean => getExperimentBucket(context, experimentName) === value;
